module.exports = __webpack_public_path__ + "static/media/18.88288d53.JPG";